const intlTelOpts = {
	preferredCountries: ['br', 'us', 'gb'],
	customContainer: 'full-width',
};

const useDeviceId = ['twilio', 'messageBird'];
const useNamespace = ['messageBird'];

const useQRCode = ['powerzap', 'zapi'];

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
};

export { formItemLayout, intlTelOpts, useDeviceId, useNamespace, useQRCode };
